<template>
  <a :href="`${$store.state.SOCO_WEB_URL}/${username}/timeline`" target="_blank" rel="noopener">
    <div class="avatar-wrapper">
      <template v-if="src">
        <div v-if="isExpertReview" class="expert-reviewer-avatar">
          <img
            :src="isUseBase64 ? imgBase64 : ownerImage(src)"
            :class="className"
            :alt="username"
            height="32"
            width="32"
            @error="imageLoadError"
          />
        </div>
        <img v-else :src="ownerImage(src)" :class="className" :alt="username" @error="imageLoadError" />
      </template>
      <img v-else src="/assets/img/default-avatar.png" :class="className" alt="icon-default-avatar" />
      <img
        v-if="userLevel && !isExpertReview"
        class="avatar-user-level"
        :src="isExpertReview ? '/assets/img/expert-review-check-icon.svg' : getUserLevelAvatar"
        :alt="getSocoLevelName(userLevel)"
        height="16"
        width="16"
        @error="onSocoLevelImageError"
      />
      <img
        v-else-if="user && isExpertReview"
        class="avatar-user-level"
        src="/assets/img/icon_expert_review.svg"
        :alt="getSocoLevelName(userLevel)"
        height="16"
        width="16"
      />
    </div>
  </a>
</template>

<script>
import { LEVEL_CODES, getLevelCode, socoLevelMixin } from '@/shared/soco-levels';

export default {
  name: 'global-imageuser',
  mixins: [socoLevelMixin],
  props: {
    className: {
      type: String,
      required: true,
      default: () => '',
    },
    // eslint-disable-next-line vue/require-prop-types
    username: {
      required: true,
      default: () => '',
    },
    // eslint-disable-next-line vue/require-prop-types
    src: {
      required: true,
    },
    userLevel: {
      type: String,
      required: false,
      default: () => '',
    },
    // eslint-disable-next-line vue/require-default-prop
    user: {
      type: Object,
      required: false,
    },
    isExpertReview: {
      type: Boolean,
      default: false,
    },
    isUseBase64: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      imgBase64: '',
    };
  },
  computed: {
    getUserLevelAvatar() {
      switch (getLevelCode(this.userLevel)) {
        case LEVEL_CODES.MEMBER:
        case LEVEL_CODES.SILVER:
        case LEVEL_CODES.PLATINUM:
          return this.getSocoLevelImage(this.userLevel);
        default:
          // no own icon (gold or not a level): the lowest level's icon, as before
          return this.getSocoLevelImage(LEVEL_CODES.MEMBER);
      }
    },
  },
  mounted() {
    this.setSrcToBase64();
  },
  updated() {
    this.setSrcToBase64();
  },
  methods: {
    ownerImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=60',
        image: src,
      });
    },
    imageLoadError(event) {
      event.target.src = '/assets/img/default-avatar.png';
    },
    async setToBase64(url, state) {
      try {
        delete axios.defaults.withCredentials;
        const { data } = await axios.get(url, { responseType: 'blob', headers: { 'Cache-Control': 'no-cache' } });
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(data);
          reader.onloadend = () => {
            const { result } = reader;
            this[state] = result;
            resolve(result);
          };
          reader.onerror = reject;
        });
      } catch (err) {
        console.error(err);
        return url;
      } finally {
        axios.defaults.withCredentials = true;
      }
    },
    setSrcToBase64() {
      if (this.isUseBase64 && this.src) {
        this.setToBase64(this.src, 'imgBase64');
      }
    },
  },
};
</script>
